module.exports = __webpack_public_path__ + "static/media/error-icon@2x.7689c0f5.png";